// these affects PageTitle and Content
export const CONTENT_X_MARGIN_DESKTOP = 48
export const CONTENT_X_MARGIN = CONTENT_X_MARGIN_DESKTOP / 1.25

// 66 is the width of the collapsed sidebar
export const COLLAPSED_MARGIN_LEFT = 66
export const EXPANDED_MARGIN_LEFT = 240
